import Bareme from "./utils/bareme";
import { round10 } from "round10";

import getSetting from "./getSetting";
import { ETAT_VS_ETUDE } from "./components/viewer/Viewer";

const computationApp = {
    code: "vente-gre-gre-bxl",
    name: "Vente de Gré à Gré (Bruxelles)",
    mainField: "prix",
    defaultValue: {
        prix: 0,
        annexe: false,
        abattement: false,
        abattementTerrain: false,
        nombreBiens: 0,
        overrideFraisDivers: false,
        nombreBureauxSupplementaires: 0,
        fraisDivers: 0
    },
    compute: (settings, value) => {
        const bareme = new Bareme("J");
        let honoraire = bareme.compute(value.prix).total;
        const tauxTva = 0.21;
        /*------------------------------------*\
        #Region : bruxelles
    \*------------------------------------*/

        let droitEnregistrement = 0;
        let droitEnregistrementLabel = "Droits d'enregistrement";

        /*------------------------------------*\
        #Abattement (175 000€) ou terrain (87.500€)
    \*------------------------------------*/
        if (value.abattement && value.prix <= 500000 /*Max 500.000€ */) {
            droitEnregistrement = (12.5 / 100) * (value.prix - 175000);
            droitEnregistrementLabel = "Droits d'enregistrement (Abattement 175.000€)";
        } else if (value.abattementTerrain && value.prix <= 250000 /*Max 250.000€*/) {
            droitEnregistrement = (12.5 / 100) * (value.prix - 87500);
            droitEnregistrementLabel = "Droits d'enregistrement (Abattement 87.500€)";
        } else {
            droitEnregistrement = (12.5 / 100) * value.prix;
        }

        /*------------------------------------*\
        #Montant minimum
    \*------------------------------------*/
        if (droitEnregistrement < 50) {
            droitEnregistrement = 50;
        }

        droitEnregistrement = round10(droitEnregistrement, -2);
        let droitEnregistrementArray = [];

        droitEnregistrementArray.push({
            label: droitEnregistrementLabel,
            value: droitEnregistrement,
            etat: true,
            tva: false
        });

        if (value.annexe) {
            droitEnregistrementArray.push({
                label: "Annexe(s)",
                value: 100,
                etat: true,
                tva: false
            });
        }

        let droitEcriture = getSetting("droit_ecriture", settings);

        let eRegistration = getSetting("e_registration", settings);

        let fraisDivers = 0;
        if (value.overrideFraisDivers) {
            fraisDivers = value.fraisDivers;
        } else {
            fraisDivers = getSetting("frais_divers_vente_gre_a_gre_bruxelles", settings);
            fraisDivers += value.nombreBiens * getSetting("frais_divers_ajout_par_bien", settings);
        }

        let tva = tauxTva * (honoraire + droitEcriture + fraisDivers + eRegistration);

        let transcription = getSetting("transcription", settings);
        let { nombreBureauxSupplementaires } = value;
        let label = "Transcription";
        let valueTranscription = transcription;
        if (nombreBureauxSupplementaires > 0) {
            label = `Transcription (${value.nombreBureauxSupplementaires} bureau${
                value.nombreBureauxSupplementaires > 1 ? "x" : ""
            } supplémentaire${value.nombreBureauxSupplementaires > 1 ? "s" : ""})`;
            valueTranscription = transcription * (value.nombreBureauxSupplementaires + 1);
        }
        let transcriptionSerie = {
            label,
            value: valueTranscription,
            etat: true,
            tva: false
        };

        /*------------------------------------*\
        Round all the shit
    \*------------------------------------*/

        tva = round10(tva, -2);

        var result = [
            ...droitEnregistrementArray,
            transcriptionSerie,
            {
                label: "Honoraire",
                value: honoraire,
                etat: false,
                tva: true
            },
            {
                label: "Droits d'écriture",
                value: droitEcriture,
                etat: true,
                tva: true
            },
            {
                label: "E-registration",
                value: eRegistration,
                etat: true,
                tva: true
            },
            {
                label: "Frais divers et recherches",
                value: fraisDivers,
                frais: true,
                tva: true
            },
            {
                label: "TVA",
                value: tva,
                etat: true,
                tva: true
            }
        ];
        return {
            typeVisualisation: ETAT_VS_ETUDE,
            series: result
        };
    }
};

export default computationApp;



// WEBPACK FOOTER //
// ./src/computationApps/vente-gre-gre-bruxelles.js